/**
 * Kurumlar Vergisi Hesaplama Engine
 * 2026 — Genel oran %25, finans sektörü %30, ihracat/sanayi %20, halka arz %23
 */

export const YILI = 2026;

export type KurumTipi = "genel" | "finans" | "ihracat" | "sanayi" | "halka_arz";

export interface KurumlarVergisiOran {
  value: KurumTipi;
  label: string;
  oran: number;
  aciklama: string;
}

export const KURUM_TIPLERI: KurumlarVergisiOran[] = [
  {
    value: "genel",
    label: "Genel",
    oran: 0.25,
    aciklama: "Standart kurumlar vergisi oranı",
  },
  {
    value: "finans",
    label: "Finans Sektörü",
    oran: 0.3,
    aciklama: "Bankalar, sigorta, leasing, faktoring, ödeme kuruluşları",
  },
  {
    value: "ihracat",
    label: "İhracat",
    oran: 0.2,
    aciklama: "Münhasıran ihracattan elde edilen kazançlar (5 puan indirimli)",
  },
  {
    value: "sanayi",
    label: "Sanayi / Üretim",
    oran: 0.24,
    aciklama:
      "Sanayi sicil belgeli, fiilen üretim faaliyetiyle iştigal eden kurumlar (1 puan indirimli)",
  },
  {
    value: "halka_arz",
    label: "Halka Arz (İlk %20+)",
    oran: 0.23,
    aciklama: "BİST'te ilk defa %20+ oranında halka arz edilen kurumlar",
  },
];

export interface KurumlarVergisiGirdi {
  kurumTipi: KurumTipi;
  yillikKazanc: number;
  gecmisYilZarar?: number;
}

export interface KurumlarVergisiSonuc {
  kurumTipi: KurumlarVergisiOran;
  yillikKazanc: number;
  gecmisYilZarar: number;
  vergiMatrahi: number;
  vergiOrani: number;
  hesaplananVergi: number;
  vergiSonrasiKar: number;
  efektifOran: number;
  ceyreklikTaksitler: number[];
}

export function formatTL(value: number): string {
  return new Intl.NumberFormat("tr-TR", {
    style: "currency",
    currency: "TRY",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}

export function formatOran(value: number): string {
  return `%${(value * 100).toFixed(2)}`;
}

export function hesaplaKurumlarVergisi(
  girdi: KurumlarVergisiGirdi
): KurumlarVergisiSonuc {
  const kazanc = Math.max(0, girdi.yillikKazanc || 0);
  const zarar = Math.max(0, girdi.gecmisYilZarar || 0);
  const kurumTipi =
    KURUM_TIPLERI.find((k) => k.value === girdi.kurumTipi) || KURUM_TIPLERI[0];

  const vergiMatrahi = Math.max(0, kazanc - zarar);
  const hesaplananVergi = vergiMatrahi * kurumTipi.oran;
  const vergiSonrasiKar = kazanc - hesaplananVergi;
  const efektifOran = kazanc > 0 ? hesaplananVergi / kazanc : 0;

  // Çeyreklik geçici vergi taksitleri (eşit dağılım)
  const ceyreklikTaksit = hesaplananVergi / 4;
  const ceyreklikTaksitler = [
    ceyreklikTaksit,
    ceyreklikTaksit,
    ceyreklikTaksit,
    ceyreklikTaksit,
  ];

  return {
    kurumTipi,
    yillikKazanc: kazanc,
    gecmisYilZarar: zarar,
    vergiMatrahi,
    vergiOrani: kurumTipi.oran,
    hesaplananVergi,
    vergiSonrasiKar,
    efektifOran,
    ceyreklikTaksitler,
  };
}
